'use strict';

import {isRoofExists} from "../../../functions";
import {flatLabelPositionChange, flatLabels, flatLabelsRemove} from "./flatLabels";
import {settingsData} from "../../../settings";

export class CylinderFlatLabels {
  constructor() {
    if (isRoofExists())
      return;

    flatLabels({currentFloor: settingsData.currentFloor, location: 'cylinder'});
    flatLabelPositionChange({x: 0, y: 0, z: 0});
  }

  static remove() {
    flatLabelsRemove();
  }
}